import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";

const CHECK_INTERVAL_MS = 30_000;

export default function useDailyReminder() {
  const { user } = useAuth();

  useEffect(() => {
    if (!user?.reminder_enabled || !user?.reminder_time) return;
    if (typeof Notification === "undefined" || Notification.permission !== "granted") return;

    const check = () => {
      const now = new Date();
      const hhmm = `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;
      const todayKey = now.toISOString().slice(0, 10);
      if (hhmm === user.reminder_time && localStorage.getItem("attune_last_reminder") !== todayKey) {
        localStorage.setItem("attune_last_reminder", todayKey);
        new Notification("Attune — a moment of stillness", {
          body: "Take a breath. Open your heart and attune to the Holy Spirit today.",
        });
      }
    };

    check();
    const id = setInterval(check, CHECK_INTERVAL_MS);
    return () => clearInterval(id);
  }, [user?.reminder_enabled, user?.reminder_time]);
}
